<template>
  <fragment>
    <v-navigation-drawer
      v-model="showDrawer"
      v-click-outside="handleDrawer"
      :permanent="lgAndUp"
      color="tertiary"
      width="220"
      app
      dark
      floating
    >
      <template v-slot:prepend>
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-content class="py-0">
              <v-img
                :src="require(`@/assets/${companyLink.icon}`)"
                :alt="companyLink.name"
                :height="companyLink.height"
                :width="companyLink.width"
                :contain="companyLink.contain"
              />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
      <v-list dense flat>
        <template v-for="(item, index) in sidebar">
          <v-list-group
            v-if="item.options && item.options.length > 0"
            :key="index + item.title"
            no-action
          >
            <template v-slot:activator>
              <template>
                <v-list-item-icon class="mr-6">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </template>
            </template>
            <v-list-item
              v-for="(option, index) in item.options"
              :key="option.title + index"
              :to="{ name: option.link, params: option.params }"
              link
              class="px-4"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-text="option.title"
                  style="font-size: 12px"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-else
            :key="item.title"
            :to="{ name: item.link, params: item.params }"
            link
          >
            <template>
              <v-list-item-icon class="mr-6">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </fragment>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";

export default {
  name: "AppAffiliateSideBar",
  mixins: [displayHelpers],
  data() {
    return {
      showDrawer: false,
    };
  },
  computed: {
    ...mapGetters(["storeInfo", "drawer"]),
    companyLink() {
      return {
        icon: "Eleven_Tickets_Negativo_Horizontal.svg",
        link: `${process.env.VUE_APP_PANEL_URL}dashboard`,
        height: 56,
        width: "100%",
        name: "eleventickets",
        contain: true,
      };
    },
    sidebar() {
      return [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard-outline",
          link: "home",
          params: {},
          options: [],
        },
        {
          title: this.$t("terms.acceptance-terms"),
          icon: "mdi-file-document-edit-outline",
          link: "termos-afiliados",
          params: {},
          options: [],
        },
        {
          title: "Ranking",
          icon: "mdi-trophy-variant-outline",
          link: "ranking-afiliados",
          params: {},
          options: [],
        },
      ];
    },
  },
  watch: {
    drawer() {
      this.showDrawer = this.drawer;
    },
    showDrawer() {
      if (!this.showDrawer) this.toggleDrawer(false);
    },
  },
  mounted() {
    if (!this.showDrawer) this.toggleDrawer(false);
  },
  methods: {
    ...mapMutations(["toggleDrawer"]),
    handleDrawer() {
      if (!this.showDrawer) this.toggleDrawer(false);
    },
  },
};
</script>

<style scoped>
* {
  color: #ffffff !important;
}
</style>
